/**
 * @file Topbar 顶栏
 * @description 后台顶部条：左侧插槽 + 右侧操作。
 *
 * @whenToUse Admin Layout 顶部。
 * @whenNotToUse 页面内容标题（用 PageHeader）。
 */

import type { ReactNode } from 'react'
import { cn } from '@/lib/cn.ts'

export type TopbarProps = {
  /** 左侧（面包屑、折叠按钮等） */
  left?: ReactNode
  /** 右侧操作 */
  right?: ReactNode
  className?: string
}

export function Topbar({ left, right, className }: TopbarProps) {
  return (
    <header
      className={cn(
        'flex h-14 shrink-0 items-center justify-between gap-4 border-b border-border bg-raised px-4',
        className,
      )}
    >
      <div className="flex min-w-0 flex-1 items-center gap-3">{left}</div>
      <div className="flex shrink-0 items-center gap-5">{right}</div>
    </header>
  )
}
